import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) {}
  
  /**
   * Build API URL from endpoint path
   */
  private buildUrl(endpoint: string): string {
    return `${environment.apiUrl}${endpoint}`;
  }
  
  /**
   * Generic GET request with support for query parameters and custom headers
   */
  get<T>(endpoint: string, params?: any, options?: { headers?: {[key: string]: string} }): Observable<T> {
    let httpParams = new HttpParams();
    
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    
    const httpOptions = {
      headers: new HttpHeaders(options?.headers || {}),
      params: httpParams
    };
    
    return this.http.get<T>(this.buildUrl(endpoint), httpOptions);
  }
  
  /**
   * Generic POST request with support for custom headers
   */
  post<T>(endpoint: string, data: any, options?: { headers?: {[key: string]: string} }): Observable<T> {
    const httpOptions = {
      headers: new HttpHeaders(options?.headers || {})
    };
    
    return this.http.post<T>(this.buildUrl(endpoint), data, httpOptions);
  }
  
  /**
   * Generic PUT request with support for custom headers
   */
  put<T>(endpoint: string, data: any, options?: { headers?: {[key: string]: string} }): Observable<T> {
    const httpOptions = {
      headers: new HttpHeaders(options?.headers || {})
    };
    
    return this.http.put<T>(this.buildUrl(endpoint), data, httpOptions);
  }
  
  /**
   * Generic PATCH request with support for custom headers
   */
  patch<T>(endpoint: string, data: any, options?: { headers?: {[key: string]: string} }): Observable<T> {
    const httpOptions = {
      headers: new HttpHeaders(options?.headers || {})
    };
    
    return this.http.patch<T>(this.buildUrl(endpoint), data, httpOptions);
  }
  
  /**
   * Generic DELETE request with support for custom headers
   */
  delete<T>(endpoint: string, options?: { headers?: {[key: string]: string}, body?: any }): Observable<T> {
    const httpOptions = {
      headers: new HttpHeaders(options?.headers || {}),
      body: options?.body
    };
    
    return this.http.delete<T>(this.buildUrl(endpoint), httpOptions);
  }
}